module.exports = __webpack_public_path__ + "static/media/slick.woff";


//////////////////
// WEBPACK FOOTER
// ./~/slick-carousel/slick/fonts/slick.woff
// module id = 860
// module chunks = 3